import React, { useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import { CircularProgress } from "@mui/material";

import CandleChart from "../Components/CandleChart";
import { getPortfolio } from "../Service/data";
import TimeControl from "../Components/TimeControl";
import IndicatorSelector from "../Components/IndicatorSelector";

import { useTheme } from "@mui/material/styles";

const TICKERS_MAPPING = {
  "Keep Very Close Eye": [
    "0P00017V11.L",
    "MC.PA",
    "TLT",
    "DNLM.L",
    "BOOM.L",
    "IIND.L",
  ],
  "Monitor List": [
    "TKWY.AS",
    "OCDO.L",
    "AZN.L",
    "AMZN",
    "GSK.L",
    "AAPL",
    "RR.L",
    "BOOM.L",
  ],
  Bapa: ["0P0000GBB2.L", "0P0000GBB2.L", "HFEL.L"],
  Ramnik: ["ARB.L", "CWR.L", "QS", "DARK.L", "OCDO.L", "SPCE", "CVNA", "RIOT"],
  "Ramnik Bapa": ["ITM.L", "IQE.L"],
  "Santa SIP": ["SSON.L", "QQQ"],
  "Santa Bapa": ["BTBT", "QS", "GRG.L"],
  Nikita: ["MARA", "GDX", "BRSC.L", "RIOT"],
  Jessica: ["FCSS.L", "THRG.L"],
  Nayah: ["PCT.L", "GB00B8F8YX59.L"],
  Premila: ["HSL.L"],
  Nutan: ["BGUK.L", "HSL.L", "SBO.L"],
  Sanjeeta: [
    "ARB.L",
    "IBZL.L",
    "IGC.L",
    "0MOH.IL",
    "KWEB",
    "GDX",
    "IEFV.L",
    "GB00B8F8YX59.L",
    "0MOM.IL",
    "FAS.L",
  ],
  "Pritesh SIPP": ["HSL.L", "0P0000Y1TJ.L", "SBO.L"],
  "Pritesh ISA": ["BGUK.L", "ANII.L", "0P00000QWE.L", "0P0000JMNY.L"],
  "General Ideas": [
    "BTBT",
    "TKWY.AS",
    "EWZ",
    "FCSS.L",
    "PCT.L",
    "IUSA.L",
    "CNA.L",
    "^SPX",
    "GDX",
    "THRG.L",
    "BNKE.PA",
    "EXH7.DE",
    "GB00B8F8YX59.L",
    "PMGR.L",
    "BRSC.L",
    "RR.L",
    "RIOT",
    "0P0000OQWI",
  ],
  'Parth"s List': [
    "DEVYANI.NS",
    "EMAMILTD.NS",
    "JPPOWER.NS",
    "MAHABANK.NS",
    "IRCON.NS",
  ],
  "Screener AI - Assembly - Testing and Packageing": ["TER", "AMKR", "CDNS"],
  "Screener AI - Equipment": [
    "HTHIY",
    "KLAC",
    "LRCX",
    "ASM.AS",
    "ASML.AS",
    "BESI.AS",
    "AMAT",
    "AIXA.DE",
    "AMD",
    "NVDA",
  ],
  "Screener AI - Fabless Design": ["AVGO", "QCOM"],
  "Screener AI - Foundaries": ["GFS", "UMC"],
  "Screener AI - Integrated Devices Manufacturer": [
    "SMSN.IL",
    "IFX.DE",
    "TXN",
    "ADI",
    "INTC",
  ],
  "Screener AI - Raw Materials": ["WAF.DE"],
  Hemesh: [
    "0P00017EQA.L",
    "0P000125KV.L",
    "0P000102M3.L",
    "0P000102MM.L",
    "0P0000XYWQ.L",
    "IIND.L",
  ],
};

function PortfolioPage() {
  const [value, setValue] = useState(0);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [noData, setNoData] = useState(true);

  useEffect(() => {
    getPortfolio().then((data) => {
      setData(data);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    if (data !== undefined && data !== null) {
      setLoading(false);
      setNoData(false);
    }
  }, [data]);

  const theme = useTheme();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div
      style={{
        paddingLeft: "20px",
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        minWidth: "100vw",
        background: `${theme.palette.background.default}`,
      }}
    >
      {loading && <CircularProgress />}
      {noData ? (
        <Typography>No data was received</Typography>
      ) : (
        <div>
          <Box
            sx={{
              width: "100%",
              bgcolor: `${theme.palette.background.default}`,
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="Ticker Tabs"
              sx={{
                borderBottom: `1px solid ${theme.palette.divider}`,
                "& .MuiTabs-flexContainer": {
                  flexWrap: "wrap",
                },
              }}
            >
              {Object.keys(data).map((key, index) => (
                <Tab
                  key={index}
                  label={key}
                  sx={{
                    color: theme.palette.text.primary,
                  }}
                />
              ))}
            </Tabs>
            {Object.keys(data).map((key, index) => (
              <TabPanel key={index} value={value} index={index}>
                <Typography sx={{ color: theme.palette.text.secondary }}>
                  {key}:
                </Typography>
                <TimeControl/>
                <IndicatorSelector/>
                <ul>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",
                    }}
                  >
                    {data[key].map((item, index) => (
                      <div key={`${item}_${index}`}>
                        <CandleChart
                          key={`${index}_${item}`}
                          title={item}
                          width={600}
                          height={600}
                          renderOptions={true}
                          onRemove={() => {}}
                        ></CandleChart>
                      </div>
                    ))}
                  </div>
                </ul>
              </TabPanel>
            ))}
          </Box>
        </div>
      )}
    </div>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default PortfolioPage;
